<template>
  <tr role="row">
    <slot></slot>
  </tr>
</template>

<script>
export default {
    name: "BsGridRowhead"
}
</script>

<style scoped>

</style>
